import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createFeatureRequest = { feature: '_feature' };
var _createFeatureResponse = { feature: '_feature' };
var _createPlanRequest = { plan: '_plan' };
var _createPlanResponse = { plan: '_plan' };
var _createPlanTranslationRequest = { planTranslation: '_planTranslation' };
var _createPlanTranslationResponse = { planTranslation: '_planTranslation' };
var _deleteFeatureRequest = {};
var _deleteFeatureResponse = {};
var _deletePlanTranslationRequest = {};
var _deletePlanTranslationResponse = {};
var _feature = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _getFeatureRequest = {};
var _getFeatureResponse = { feature: '_feature' };
var _getPlanRequest = {};
var _getPlanResponse = { plan: '_plan' };
var _getPlanTranslationRequest = {};
var _getPlanTranslationResponse = { planTranslation: '_planTranslation' };
var _plan = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _planTranslation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _publishPlanRequest = {};
var _publishPlanResponse = {};
var _queryFeaturesRequest = {};
var _queryFeaturesResponse = { features: '_feature' };
var _queryPlansRequest = {};
var _queryPlansResponse = { plans: '_plan' };
var _queryPlanTranslationsRequest = {};
var _queryPlanTranslationsResponse = { planTranslations: '_planTranslation' };
var _updateFeatureRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    feature: '_feature',
};
var _updateFeatureResponse = { feature: '_feature' };
var _updatePlanDraftRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    plan: '_plan',
};
var _updatePlanDraftResponse = { plan: '_plan' };
var _updatePlanTranslationRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    planTranslation: '_planTranslation',
};
var _updatePlanTranslationResponse = { planTranslation: '_planTranslation' };
function resolveWixDevcenterPlansV1PlansUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/plans',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixDevcenterPlansV1FeaturesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/plans',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixDevcenterPlansV1PlanTranslationsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/plans',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
            {
                srcPath: '/v1/plans',
                destPath: '/v1/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createPlanTranslation(payload) {
    var _a = serializer(_createPlanTranslationRequest, { _planTranslation: _planTranslation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPlanTranslationResponse, {
        _planTranslation: _planTranslation,
    }).fromJSON;
    function __createPlanTranslation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.PlanTranslations.CreatePlanTranslation',
            url: resolveWixDevcenterPlansV1PlanTranslationsUrl({
                protoPath: '/v1/plans/{planTranslation.planId}/translations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPlanTranslation.fromReq = fromReq;
    __createPlanTranslation.__isAmbassador = true;
    return __createPlanTranslation;
}
export function getPlanTranslation(payload) {
    var _a = serializer(_getPlanTranslationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlanTranslationResponse, {
        _planTranslation: _planTranslation,
    }).fromJSON;
    function __getPlanTranslation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'GET',
            methodFqn: 'wix.devcenter.plans.v1.PlanTranslations.GetPlanTranslation',
            url: resolveWixDevcenterPlansV1PlanTranslationsUrl({
                protoPath: '/v1/plans/{id}/translations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlanTranslation.fromReq = fromReq;
    __getPlanTranslation.__isAmbassador = true;
    return __getPlanTranslation;
}
export function updatePlanTranslation(payload) {
    var _a = serializer(_updatePlanTranslationRequest, { _planTranslation: _planTranslation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePlanTranslationResponse, {
        _planTranslation: _planTranslation,
    }).fromJSON;
    function __updatePlanTranslation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.plans.v1.PlanTranslations.UpdatePlanTranslation',
            url: resolveWixDevcenterPlansV1PlanTranslationsUrl({
                protoPath: '/v1/plans/{planTranslation.id}/translations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePlanTranslation.fromReq = fromReq;
    __updatePlanTranslation.__isAmbassador = true;
    return __updatePlanTranslation;
}
export function deletePlanTranslation(payload) {
    var _a = serializer(_deletePlanTranslationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePlanTranslationResponse, {}).fromJSON;
    function __deletePlanTranslation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'DELETE',
            methodFqn: 'wix.devcenter.plans.v1.PlanTranslations.DeletePlanTranslation',
            url: resolveWixDevcenterPlansV1PlanTranslationsUrl({
                protoPath: '/v1/plans/{id}/translations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePlanTranslation.fromReq = fromReq;
    __deletePlanTranslation.__isAmbassador = true;
    return __deletePlanTranslation;
}
export function queryPlanTranslations(payload) {
    var _a = serializer(_queryPlanTranslationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPlanTranslationsResponse, {
        _planTranslation: _planTranslation,
    }).fromJSON;
    function __queryPlanTranslations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.PlanTranslations.QueryPlanTranslations',
            url: resolveWixDevcenterPlansV1PlanTranslationsUrl({
                protoPath: '/v1/plans/translations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPlanTranslations.fromReq = fromReq;
    __queryPlanTranslations.__isAmbassador = true;
    return __queryPlanTranslations;
}
/** Creates a Feature. */
export function createFeature(payload) {
    var _a = serializer(_createFeatureRequest, { _feature: _feature }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFeatureResponse, {
        _feature: _feature,
    }).fromJSON;
    function __createFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.Features.CreateFeature',
            url: resolveWixDevcenterPlansV1FeaturesUrl({
                protoPath: '/v1/features',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFeature.fromReq = fromReq;
    __createFeature.__isAmbassador = true;
    return __createFeature;
}
/** Updates a Feature. */
export function updateFeature(payload) {
    var _a = serializer(_updateFeatureRequest, { _feature: _feature }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFeatureResponse, {
        _feature: _feature,
    }).fromJSON;
    function __updateFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.plans.v1.Features.UpdateFeature',
            url: resolveWixDevcenterPlansV1FeaturesUrl({
                protoPath: '/v1/features/{feature.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFeature.fromReq = fromReq;
    __updateFeature.__isAmbassador = true;
    return __updateFeature;
}
export function getFeature(payload) {
    var _a = serializer(_getFeatureRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeatureResponse, { _feature: _feature }).fromJSON;
    function __getFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'GET',
            methodFqn: 'wix.devcenter.plans.v1.Features.GetFeature',
            url: resolveWixDevcenterPlansV1FeaturesUrl({
                protoPath: '/v1/features/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeature.fromReq = fromReq;
    __getFeature.__isAmbassador = true;
    return __getFeature;
}
export function deleteFeature(payload) {
    var _a = serializer(_deleteFeatureRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFeatureResponse, {}).fromJSON;
    function __deleteFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'DELETE',
            methodFqn: 'wix.devcenter.plans.v1.Features.DeleteFeature',
            url: resolveWixDevcenterPlansV1FeaturesUrl({
                protoPath: '/v1/features/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFeature.fromReq = fromReq;
    __deleteFeature.__isAmbassador = true;
    return __deleteFeature;
}
export function queryFeatures(payload) {
    var _a = serializer(_queryFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryFeaturesResponse, {
        _feature: _feature,
    }).fromJSON;
    function __queryFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.Features.QueryFeatures',
            url: resolveWixDevcenterPlansV1FeaturesUrl({
                protoPath: '/v1/features/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFeatures.fromReq = fromReq;
    __queryFeatures.__isAmbassador = true;
    return __queryFeatures;
}
/**
 * Creates a Plan.
 *
 * The request body must include lorem_uppercase and business address. Ipsum is optional.
 */
export function createPlan(payload) {
    var _a = serializer(_createPlanRequest, {
        _plan: _plan,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPlanResponse, { _plan: _plan }).fromJSON;
    function __createPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.Plans.CreatePlan',
            url: resolveWixDevcenterPlansV1PlansUrl({
                protoPath: '/v1/plans',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPlan.fromReq = fromReq;
    __createPlan.__isAmbassador = true;
    return __createPlan;
}
/** Retrieves a Plan. */
export function getPlan(payload) {
    var _a = serializer(_getPlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPlanResponse, { _plan: _plan }).fromJSON;
    function __getPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'GET',
            methodFqn: 'wix.devcenter.plans.v1.Plans.GetPlan',
            url: resolveWixDevcenterPlansV1PlansUrl({
                protoPath: '/v1/plans/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPlan.fromReq = fromReq;
    __getPlan.__isAmbassador = true;
    return __getPlan;
}
/**
 * Updates a Plan draft.
 * Each time the Plan is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the Plan.
 * This ensures you're working with the latest Plan
 * and prevents unintended overwrites.
 */
export function updatePlanDraft(payload) {
    var _a = serializer(_updatePlanDraftRequest, { _plan: _plan }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePlanDraftResponse, { _plan: _plan }).fromJSON;
    function __updatePlanDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'PATCH',
            methodFqn: 'wix.devcenter.plans.v1.Plans.UpdatePlanDraft',
            url: resolveWixDevcenterPlansV1PlansUrl({
                protoPath: '/v1/plans/{plan.planId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePlanDraft.fromReq = fromReq;
    __updatePlanDraft.__isAmbassador = true;
    return __updatePlanDraft;
}
/**
 * Retrieves a list of Plans, given the provided [paging, filtering, and sorting][1].
 * Up to 1,000 Plans can be returned per request.
 * To learn how to query Plans, see [API Query Language][2].
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryPlans(payload) {
    var _a = serializer(_queryPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPlansResponse, { _plan: _plan }).fromJSON;
    function __queryPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.Plans.QueryPlans',
            url: resolveWixDevcenterPlansV1PlansUrl({
                protoPath: '/v1/plans/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPlans.fromReq = fromReq;
    __queryPlans.__isAmbassador = true;
    return __queryPlans;
}
/**
 * Creates a Plan.
 *
 * The request body must include lorem_uppercase and business address. Ipsum is optional.
 */
export function publishPlan(payload) {
    var _a = serializer(_publishPlanRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishPlanResponse, {}).fromJSON;
    function __publishPlan(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.plans.v1.plan',
            method: 'POST',
            methodFqn: 'wix.devcenter.plans.v1.Plans.PublishPlan',
            url: resolveWixDevcenterPlansV1PlansUrl({
                protoPath: '/v1/plans/{planId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishPlan.fromReq = fromReq;
    __publishPlan.__isAmbassador = true;
    return __publishPlan;
}
//# sourceMappingURL=http.impl.js.map